import * as model from './model.js';
// Pollyfilling everything else
import 'core-js/stable';
// Used for polyfilling async/await
import 'regenerator-runtime/runtime';
import recipeView from './views/recipeView.js';
import searchView from './views/searchView.js';
import resultsView from './views/resultsView.js';
import paginationView from './views/paginationView.js';
import bookmarksView from './views/bookmarksView.js';
import addRecipeView from './views/addRecipeView.js';
import { MODAL_CLOSE_SEC } from './config.js';


// https://forkify-api.herokuapp.com/v2

///////////////////////////////////////

// if(module.hot) {
//   module.hot.accept();
// } 


const controlRecipes = async function () {
  try {
    // We slice() for removing the #
    const id = window.location.hash.slice(1);
    if (!id) return;
    recipeView.renderSpinner();

    // 0) Update results view to mark selected search result
    // Using our DOM updating algorithm, we will update the results markup so we can apply the logic
    // from _generateMarkupPreview from resultsView.js. This way we will detect that now certain result
    // has the class 'preview__link--active' and we will update that element so it can be highlighted
    resultsView.update(model.getSearchResultsPage());
    /* 
    We could be also using render() for that, because when we click a result item, the URI hash would change,
    the results view would be re-rendered, it would eventually call _generateMarkup and _generateMarkupPreview
    and will apply the highlight logic. The issue would be that all preview images would be re-loaded each time
    */
    //resultsView.render(model.getSearchResultsPage());
    
    // 1) Updating bookmarks view
    bookmarksView.update(model.state.bookmarks);


    // 2) Loading recipe
    // This is the case were we're calling an async function inside of a parent one (controlRecipes)
    await model.loadRecipe(id);

    // 3) Rendering recipe
    recipeView.render(model.state.recipe);
    /* 
       This is the syntax advantatge of importing an object instance
       Otherwise we would do the following:
       const recipeView = new recipeView(model.state.recipe);
       recipeView.blablabla
    */


  } catch (err) {
    console.error(err);
    // We do not pass any args because we have a default one inside the recipeView class
    recipeView.renderError();
    console.log(err);
  }
};

const controlSearchResults = async function() {
  try {
    resultsView.renderSpinner();
    
    // 1) Get search query
    const query = searchView.getQuery();
    
    //if(!query) return;
    // 2) Load search results
    await model.loadSearchResults(query);
    
    // 3) Render NEW results
    resultsView.render(model.getSearchResultsPage());

    // Render NEW initial pagination buttons
    paginationView.render(model.state.search);

  } catch(err) {
    console.error(err);
  }
};

// Publisher-Subscriber pattern 
const controlPagination = function(goToPage) {
  // 3) Render NEW results
  resultsView.render(model.getSearchResultsPage(goToPage));

  // Render NEW initial pagination buttons
  paginationView.render(model.state.search);
}

// Servings = For how much people the recipe is for
const controlServings = function(newServings) {
  // Update the recipe servings (in state)
  model.updateServings(newServings);
  // Update the recipe view (Recipe content)
  // Instead of using the render method, we will be using our own DOM updating alghorithm.
  // This way we will avoid the flittering when we update the servings. Besides the browser will try
  // to download the same recipe image each time we update, and that's not what we want
  // recipeView.render(model.state.recipe);
  recipeView.update(model.state.recipe);
};

// This function will be invocked when we click the bookmark button inside recipe
const controlAddBookmark = function() {
  // Adding / removing bookmark prop for the current recipe
  if(!model.state.recipe.bookmarked) {
    model.addBookmark();
  } else {
    model.deleteBookmark();
  }

  // 2) Update recipe view
  recipeView.update(model.state.recipe);


  // 3) Render bookmarks
  bookmarksView.render(model.state.bookmarks);


  // Removing bookmark for the current recipe
  //  model.deleteBookmark();

}

const controlBookmarks = function() {
  bookmarksView.render(model.state.bookmarks);
}


const controlAddRecipe = async function(newRecipe) {
  try {
    // Upload new recipe data
    addRecipeView.renderSpinner();
    console.log('newRecipe: ', newRecipe);
    await model.uploadRecipe(newRecipe);

    // Rendering the new recipe
    recipeView.render(model.state.recipe);

    // Success message
    addRecipeView.renderMessage();

    // Rendering bookmark view
    bookmarksView.render(model.state.bookmarks);

    // Change URL hash (we will update the URL without having to refresh)
    // Investigate further the method
    window.history.pushState(null, '', `#${model.state.recipe.id}`);


    // Close form window (with timeout)
    setTimeout(function() {
      addRecipeView.toggleWindow();
    }, MODAL_CLOSE_SEC * 1000);

  } catch(err) {
    console.error(err);
    addRecipeView.renderError(err.message);
  }
}


// This is the implementation of the publisher-subscriber pattern. We don't need to have eventListeners
// inside the controller, so what we did is moving eventListeners to the view 'recipeView' and 'searchView' and when an
// When event is triggered it will actually call a function inside the controller
const init = function() {
  bookmarksView.addHandlerRender(controlBookmarks);
  recipeView.addHandlerRender(controlRecipes);
  recipeView.addHandlerUpdateServings(controlServings);
  recipeView.addHandlerAddBookmark(controlAddBookmark);
  searchView.addHandlerSearch(controlSearchResults);
  paginationView.addHandlerClick(controlPagination);
  // In this case, invocking that function here would be a mistake because we're not having in mind the
  // asyncronous nature when fetching the recipies. We don't have the recipies immediatly, we have to wait
  // and init is executed immediatly after JS parsing.
  //controlServings();
  addRecipeView.addHandlerUpload(controlAddRecipe);
}

init();




